import React, { useState } from "react";
import { Link } from "gatsby";
import * as styles from "./Footer.module.scss";
import Button from "../Button/Button";
import Socials from "../Socials/Socials";
import DropDownSmart from "../DropDownSmart/DropDownSmart";
import DropDown from "../DropDown/DropDown";
import { Newsletter } from "../../../services/Newsletter/Newsletter";
import WhatsappButton from "../WhatsAppButton/WhatsAppButton";
import ZanyIcon from "../../../icons/ZanyIcon";
import ODIcon from "../../../icons/ODIcon";

const Footer = ({ paises, patternCategory, childCategory }) => {
  const [email, setEmail] = useState("");
  const [responseMessage, setResponseMessage] = useState("");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await Newsletter(email);
      setResponseMessage("Gracias por suscribirte!");
      setEmail("");
    } catch (error) {
      console.error(error);
      setResponseMessage("Ocurrió un error, por favor intenta de nuevo.");
    }
  };

  return (
    <footer className={`${styles.border__top} section`}>
      <div className={`container`}>
        <div className={`${styles.column__container} align-center pr-1`}>
          <div className={`${styles.column__content} w-100`}>
            <h4>Productos</h4>
            <div className="w-100">
              <DropDownSmart
                pattern={patternCategory}
                child={childCategory}
                color="white"
              />
              <WhatsappButton />
            </div>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div className={`${styles.column__container} align-center pl-1 pr-1`}>
          <div className={`${styles.column__content} w-100`}>
            <h4>Acerca de Peabody</h4>
            <ul className={styles.list}>
              <li>
                <a
                  href="https://tienda.mercadolibre.com.ar/peabody"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Tienda
                </a>
              </li>
              <li>
                <Link to="/historia/">Nuestra historia</Link>
              </li>
              <li>
                <Link to="/novedades">Novedades</Link>
              </li>
              <li>
                <Link to="/recetas">Recetas</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div className={`${styles.column__container} align-center pl-1 pr-1`}>
          <div className={`${styles.column__content} w-100`}>
            <h4>Atención al cliente</h4>
            <ul className={styles.list}>
              <li>
                <a
                  href="https://api.whatsapp.com/send/?phone=5491126726707&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chatea con nosotros
                </a>
              </li>
              <li>
                <Link to="/servicio-tecnico/servicioTecnico">
                  Encuentra tu servicio técnico más cercano
                </Link>
              </li>
              <li>
                <Link to="/servicio-tecnico/repuestos">
                  Pide tu repuesto y accesorio
                </Link>
              </li>
              <li>
                <Link to="/servicio-tecnico/manuales">
                  Descarga de manuales y recetarios
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div className={`${styles.column__container} align-center pl-1`}>
          <h4>Subscríbete al Newsletter</h4>

          <div className={styles.main_container_form}>
            <p>Conocé antes que nadie los lanzamientos, recetas y mucho más</p>
            <form className={styles.container_form} onSubmit={handleSubmit}>
              {/* Agrega el manejador de envío aquí */}

              <input
                type="email"
                autoComplete="off"
                className={styles.newsletter__input}
                value={email}
                onChange={handleEmailChange}
                placeholder="Ingresa tu email"
              />

              <div className={styles.newsletter__button}>
                <Button type="submit" text="Subscríbete" color="black" />
              </div>

              <div className={styles.container_response}>
                {responseMessage && <p>{responseMessage}</p>}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className={`${styles.finalrow__container} ${styles.border__top} container`}
      >
        <div className={`${styles.finalrow__content}`}>
          <div className={`${styles.links}`}>
            <DropDown
              drop={"up"}
              name={"Pais"}
              options={paises}
              color={"white"}
            />
            <div className={styles.divider2} />

            <Link>Defensa del consumidor</Link>
            <div className={styles.divider2} />

            <p className={styles.copyright}>
              © Copyright 2024
              <a
                href="https://zanydev.co/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ZanyIcon />
              </a>
              <a
                href="https://od.studio/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ODIcon />
              </a>
            </p>
          </div>
          <Socials />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
